import * as API from './../base/api_service';
import * as serviceCallConfig from './../config/api_urls';

//export var CHANGE_PASSWORD = ' CHANGE_PASSWORD'; // api call
export var CHANGE_PASSWORD_DATA = ' CHANGE_PASSWORD_DATA'; // Success Response

export var PROFILE_UPDATE = 'PROFILE_UPDATE';
export var PROFILE_UPDATE_DATA = 'PROFILE_UPDATE_DATA';
export var PROFILE_UPDATE_FAILD = 'PROFILE_UPDATE_FAILD';

export var PASSWORD_VERIFICATION = 'PASSWORD_VERIFICATION';
export var PASSWORD_VERIFICATION_DATA = 'PASSWORD_VERIFICATION_DATA';
export var VERIFY_PASSWORD_FAILD = 'VERIFY_PASSWORD_FAILD';
export var GET_SECURITY_QUESTIONS_DATA = 'GET_SECURITY_QUESTIONS_DATA';
export var GET_SECURITY_QUESTIONS_DATA_FAIL = 'GET_SECURITY_QUESTIONS_DATA_FAIL';
export var GET_UPDATE_SECURITY_QUESTIONS_STATUS = 'GET_UPDATE_SECURITY_QUESTIONS_STATUS';

export var UPDATE_STATUS_STAFF_PATIENT = 'UPDATE_STATUS_STAFF_PATIENT'; // Activate or deactivate staff or patient

export var ALL_SECURITY_QUESTIONS = 'ALL_SECURITY_QUESTIONS';
export var ALL_RANDOM_SECURITY_QUESTIONS = 'ALL_RANDOM_SECURITY_QUESTIONS';
export var VERIFY_OTP = 'VERIFY_OTP';
export var SET_OTP_DATA = 'SET_OTP_DATA;'
export var RESET_OTP = 'RESET_OTP';
export var GET_OTP_DATA = 'GET_OTP_DATA'
export var SET_OTP_GET_DATA = 'SET_OTP_GET_DATA'


export var changePassword = (data) => {

    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.CHANGE_PASSWORD),//endPoint
            data,//payLoad
            serviceCallConfig.CHANGE_PASSWORD,//requestFrom
            false,//isURLEncoded
            ''//getParams
        );
    }
}
export var ChangePassResponse = (data) => ({
    type: CHANGE_PASSWORD_DATA,
    data: data
})



export var verifyOTP = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
           serviceCallConfig.API_POST,//reqType
           dispatch,//dispatch
           serviceCallConfig.get(serviceCallConfig.VERIFY_OTP),//endPoint
           data,//payLoad
           serviceCallConfig.VERIFY_OTP,//requestFrom
           false,//isURLEncoded
           getState().User.loginData.data.accessToken, //authKey
           '',//api_key
           '',//getParams
           false, //multipart
           getState().User.loginData.data.uniqueKey //uniqueKey
       );
   };
};

// export var changePassFaild = (data) => ({
//     type: PROFILE_UPDATE_FAILD,
//     data: data
// })

// Registration Profile update - with out access token
export var registrationProfileUpdate = (data) => {

    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.REGISTRATION_PROFILE_UPDATE),//endPoint
            data,//payLoad
            serviceCallConfig.REGISTRATION_PROFILE_UPDATE,//requestFrom
            false,//isURLEncoded
            "", //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            "", //uniqueKey
        );
    }
}



// profile update - with access token
export var profileUpdate = (data) => {

    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.PROFILE_UPDATE),//endPoint
            data,//payLoad
            serviceCallConfig.PROFILE_UPDATE,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );
    }
}

export var Profile_Update = (data) => ({
    type: PROFILE_UPDATE_DATA,
    data: data
})
// export var Profile_Update_Fail = (data) => ({
//     type: VERIFY_PASSWORD_FAILD,
//     data: data
// })

export var getOTP = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.TRIGGER_OTP),
            data,
            serviceCallConfig.TRIGGER_OTP,
            false,
            ''
        );
    };
}

export var resetOTPData = () => ({
    type: RESET_OTP,
    data: {}
})
export var setOTPResponseData = (data) => ({
    type: SET_OTP_DATA,
    data: data
})
export var setOTPData = (data) => ({
    type: SET_OTP_GET_DATA,
    data: data
})

export var verifyPass = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.PASS_VERIFICATION),//endPoint
            data,//payLoad
            serviceCallConfig.PASS_VERIFICATION,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );
    }
}
export var VerifyPassResponse = (data) => ({
    type: PASSWORD_VERIFICATION_DATA,
    data: data
})
export var verifyPassFaild = (data) => ({
    type: VERIFY_PASSWORD_FAILD,
    data: data
})


export var getsecurityAnswers = () => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_GET,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.GET_SECURITY_QUESTION) + getState().User.loginData.data.id,
            '',
            serviceCallConfig.GET_SECURITY_QUESTION,
            false,
            '',
        );
    }
}

export var getSecurQuesitonData = (data) => ({
    type: GET_SECURITY_QUESTIONS_DATA,
    data: data
})

export var getSecurQuesitonFail = (data) => ({
    type: GET_SECURITY_QUESTIONS_DATA_FAIL,
    data: data
})

// User selected security questions update status
export var setUpdateSecurityQuestionsStatus = (data) => ({
    type: GET_UPDATE_SECURITY_QUESTIONS_STATUS,
    data: data
});

// User selected security questions update API
export var updateSecrityQuestions = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.UPDATE_SECURITY_QUESTIONS),//endPoint
            data,//payLoad
            serviceCallConfig.UPDATE_SECURITY_QUESTIONS,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );
    };
};


export var updateStaffSatusData = (data) => ({
    type: UPDATE_STATUS_STAFF_PATIENT,
    data: data
})

export var updateStaffSatus = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.UPDATE_STATUS_STAFF_PATIENT),//endPoint
            data,//payLoad
            serviceCallConfig.UPDATE_STATUS_STAFF_PATIENT,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );
    };
};

// get all security questins
export var getAllSecurityQuestions = (data) => {

    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_GET,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.GET_ALL_SECURITY_QUESTIONS),
            '',
            serviceCallConfig.GET_ALL_SECURITY_QUESTIONS,
            '', '', '',
            data,
        );

    };
};

export var SetAllSecurityQuestions = (data) => ({
    type: ALL_SECURITY_QUESTIONS,
    data: data
})

export var getAllRandomSecurityQuestionsById = (userId) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_GET,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.GET_ALL_RANDOM_SECURITY_QUESTIONS),
            '',
            serviceCallConfig.GET_ALL_RANDOM_SECURITY_QUESTIONS,
            '', '', '',
            userId
        );

    };
};

export var setAllRandomSecurityQuestionsById = (data) => ({
    type: ALL_RANDOM_SECURITY_QUESTIONS,
    data: data
})



/** WEBPACK FOOTER **
 ** ./src/actions/settingScreen_actions.js
 **/